import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import Sidebar from '../components/Sidebar';
import TopBar from '../components/TopBar';
import { createDispatcher } from '../api/dispatchersApi';
import { useToast } from '../context/ToastContext';

function CreateDispatcher() {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (data) => {
    setSubmitting(true);
    try {
      const result = await createDispatcher(data);
      if (result.success) {
        showToast('success', 'Dispatcher created successfully.');
        navigate('/dispatchers');
      } else {
        showToast('error', result.message || 'Failed to create dispatcher.');
      }
    } catch (err) {
      showToast('error', 'Could not connect to server.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{ display: 'flex' }}>
      <Sidebar />
      <div style={{ flex: 1 }}>
        <TopBar title="Create Dispatcher" />
        <div style={{ padding: 24, maxWidth: 480 }}>
          <form onSubmit={handleSubmit(onSubmit)} style={styles.card}>
            <label style={styles.label}>Full Name</label>
            <input {...register('name', { required: true })} style={styles.input} />
            {errors.name && <p style={styles.errorText}>Required</p>}

            <label style={styles.label}>Email</label>
            <input {...register('email', { required: true })} type="email" style={styles.input} />
            {errors.email && <p style={styles.errorText}>Required</p>}

            <label style={styles.label}>Password</label>
            <input {...register('password', { required: true, minLength: 6 })} type="password" style={styles.input} />
            {errors.password && <p style={styles.errorText}>Minimum 6 characters required</p>}

            <label style={styles.label}>Phone</label>
            <input {...register('phone')} style={styles.input} />

            <div style={styles.buttonRow}>
              <button type="button" onClick={() => navigate('/dispatchers')} style={styles.cancelBtn}>
                Cancel
              </button>
              <button type="submit" disabled={submitting} style={styles.submitBtn}>
                {submitting ? '...' : 'Create Dispatcher'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

const styles = {
  card: { backgroundColor: 'white', borderRadius: 12, padding: 24, boxShadow: '0 1px 4px rgba(0,0,0,0.06)' },
  label: { display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6, marginTop: 14 },
  input: { width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid #e5e7eb', fontSize: 14, outline: 'none', boxSizing: 'border-box' },
  errorText: { color: '#dc2626', fontSize: 12, marginTop: 4 },
  buttonRow: { display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 24 },
  cancelBtn: { padding: '10px 20px', borderRadius: 8, border: '1px solid #e5e7eb', backgroundColor: 'white', color: '#374151', fontWeight: 600, fontSize: 14, cursor: 'pointer' },
  submitBtn: { padding: '10px 20px', borderRadius: 8, border: 'none', backgroundColor: '#2563eb', color: 'white', fontWeight: 700, fontSize: 14, cursor: 'pointer' },
};

export default CreateDispatcher;